export const ResidentialIndicator = {
  Residential: 'Residential',
  Commercial: 'Commercial',
  Unknown: 'Unknown',
  U: 'U',
  C: 'C',
  R: 'R',
};

export const isResidential = (indicator) => indicator === ResidentialIndicator.Residential || indicator === ResidentialIndicator.R;
export const isCommercial = (indicator) => indicator === ResidentialIndicator.Commercial || indicator === ResidentialIndicator.C;
export const isUnknown = (indicator) => indicator === ResidentialIndicator.Unknown || indicator === ResidentialIndicator.U;
export const ResidentialName = (isResidentialName) => (isResidentialName ? ResidentialIndicator.Residential : ResidentialIndicator.Unknown);
